import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PLANO_CARGA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PLANO_CARGA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('planoCargaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/planoCarga?id_cliente=${getState().auth.usuario.id_cliente || 0}&id_transportadora=${getState().auth.usuario.id_transportadora || null}`)
		.then(resp => {
			dispatch({
		        type: 'PLANO_CARGA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/planoCarga`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 0),
				largura: FormatUtils.formatarValorBanco(registro.largura, 2),
				altura: FormatUtils.formatarValorBanco(registro.altura, 2),
				comprimento: FormatUtils.formatarValorBanco(registro.comprimento, 2),
				peso_bruto: FormatUtils.formatarValorBanco(registro.peso_bruto, 2),
				peso_liquido: FormatUtils.formatarValorBanco(registro.peso_liquido, 2),
				quantidade_palete: FormatUtils.formatarValorBanco(registro.quantidade_palete, 0),
				id_cliente: getState().auth.usuario.id_cliente,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/planoCarga`, {
				...registro,
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 0),
				largura: FormatUtils.formatarValorBanco(registro.largura, 2),
				altura: FormatUtils.formatarValorBanco(registro.altura, 2),
				comprimento: FormatUtils.formatarValorBanco(registro.comprimento, 2),
				peso_bruto: FormatUtils.formatarValorBanco(registro.peso_bruto, 2),
				peso_liquido: FormatUtils.formatarValorBanco(registro.peso_liquido, 2),
				quantidade_palete: FormatUtils.formatarValorBanco(registro.quantidade_palete, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/planoCarga?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function reativar(registro) {
    return dispatch => {
        axios.post(`${consts.API_URL}/planoCarga/reativar`, registro)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaEmbalagem() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/embalagem/listarSelect?id_cliente=${getState().auth.usuario.id_cliente || 0}`)
		.then(resp => {
			dispatch({
				type: 'PLANO_CARGA_EMBALAGEM_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}